import { render, staticRenderFns } from "./SelfPickupGoodsRiderList.vue?vue&type=template&id=31c8e3d0&scoped=true"
import script from "./SelfPickupGoodsRiderList.vue?vue&type=script&lang=js"
export * from "./SelfPickupGoodsRiderList.vue?vue&type=script&lang=js"
import style0 from "./SelfPickupGoodsRiderList.vue?vue&type=style&index=0&id=31c8e3d0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c8e3d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31c8e3d0')) {
      api.createRecord('31c8e3d0', component.options)
    } else {
      api.reload('31c8e3d0', component.options)
    }
    module.hot.accept("./SelfPickupGoodsRiderList.vue?vue&type=template&id=31c8e3d0&scoped=true", function () {
      api.rerender('31c8e3d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DeliveryInfo/SelfPickupGoodsRiderList.vue"
export default component.exports